import PropTypes from "prop-types";

const MoneyFormat = ({ value }) => (
	<span>
		{parseFloat(value).toLocaleString("en-US", {
			currency: "USD",
			style: "currency"
		})}
	</span>
);

MoneyFormat.propTypes = {
	value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

MoneyFormat.defaultProps = {
	value: 0
};

export default MoneyFormat;